import Modal from 'react-bootstrap/Modal';
import React, { useContext, useState, useEffect, useRef } from 'react';
import DataContext from '../context';
import moment from 'moment';
import Skeleton from "react-loading-skeleton";
import { toast } from 'react-toastify'
const TimeSlotModal = () => {
    const contextValues = useContext(DataContext)
    const didMountRef = useRef(true)
    const [isTimeLoader, setIsTimeLoader] = useState(true);
    const [dates, setDates] = useState([]);
    const [timeSlots, setTimeSlots] = useState([]);
    const [currentActiveDate, setCurrentActiveDate] = useState('');
    const [currentActiveTime, setCurrentActiveTime] = useState('');

    useEffect(() => {
        if (didMountRef.current) {
            generateDates()
        }
        didMountRef.current = false;
    }, []);

    const resetTime = (date) => {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }

    const generateDates = () => {
        const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const shortDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        const today = new Date();
        const nextSevenDays = Array.from({ length: 7 }, (_, index) => {
            const currentDate = new Date(today);
            currentDate.setDate(today.getDate() + index);
            return {
                completeDate: currentDate.toISOString().slice(0, 10),
                date: currentDate.toLocaleDateString('en-US', { day: 'numeric' }),
                day: days[currentDate.getDay()],
                shortDay: shortDays[currentDate.getDay()]
            };
        });
        const sessionSelectedDateTime = JSON.parse(localStorage.getItem("TIME_SLOT"));
        if (sessionSelectedDateTime) {
            const { date, time } = sessionSelectedDateTime;
            if (contextValues.orderRecieveStatus === 'delivery') { 
                const storedDate = resetTime(new Date(date));
                const currentDate = resetTime(new Date());
                if (storedDate < currentDate) {   
                    localStorage.removeItem("TIME_SLOT");
                    const timeSlotData = null;
                    localStorage.setItem('TIME_SLOT', JSON.stringify(timeSlotData));
                    contextValues.setSelectedDateTime(timeSlotData);
                    const nextDate = nextSevenDays[0].completeDate;
                    setCurrentActiveDate(nextDate);
                    getScheduleTime(nextDate);
                } else {
                    setCurrentActiveDate(date);
                    getScheduleTime(date);
                }
            } else {
                const storedDateTime = new Date(`${date} ${time}`);
                const currentDateTime = new Date();
                if (storedDateTime < currentDateTime) {
                    localStorage.removeItem("TIME_SLOT");
                    const timeSlotData = null;
                    localStorage.setItem('TIME_SLOT', JSON.stringify(timeSlotData));
                    contextValues.setSelectedDateTime(timeSlotData);
                    setCurrentActiveDate(nextSevenDays[0].completeDate)
                    const selectedDate = new Date(nextSevenDays[0].completeDate);
                    generateTimeSlots(selectedDate);
                    setCurrentActiveTime(time);
                } else {
                    setCurrentActiveDate(date)
                    const selectedDate = new Date(date);
                    generateTimeSlots(selectedDate);
                    setCurrentActiveTime(time);
                }
            }
        } else {
            if (contextValues.orderRecieveStatus === 'delivery') {
                setCurrentActiveDate(nextSevenDays[0].completeDate)
                getScheduleTime(nextSevenDays[0].completeDate)
                const selectedDate = new Date(nextSevenDays[0].completeDate);
                generateTimeSlots(selectedDate);
            } else {
                setCurrentActiveDate(nextSevenDays[0].completeDate)
                const selectedDate = new Date(nextSevenDays[0].completeDate);
                generateTimeSlots(selectedDate);
            }
        }

        setDates(nextSevenDays);
    };

    const generateTimeSlots = (selectedDate = new Date()) => {
        const timeSlots = [];
        const now = new Date(); // Current date and time
        const isToday = selectedDate.toDateString() === now.toDateString(); // Check if selectedDate is today

        for (let hour = 10; hour <= 22; hour++) {
            const timeSlot = new Date(selectedDate); // Use the selected date
            timeSlot.setHours(hour, 0, 0, 0); // Set the specific hour for the selected date

            // If the selected date is today, include only future time slots
            if (!isToday || timeSlot > now) {
                const formattedTime = timeSlot.toLocaleTimeString('en-US', {
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: true,
                });
                timeSlots.push(formattedTime);
            }
        }
        if (timeSlots.length > 0) {
            setCurrentActiveTime(timeSlots[0]); // Set the first available time slot as active 
        } else {
            console.log('No available time slots for the selected date.');
            setCurrentActiveTime(null); // Handle the case where no time slots are available
        }

        setTimeSlots(timeSlots);
        setIsTimeLoader(false);
    };

    const chooseDate = async (date) => {
        setCurrentActiveDate(date.completeDate)
        const selectedDate = new Date(date.completeDate);
        generateTimeSlots(selectedDate);
    };

    const chooseTime = async (time) => {
        setCurrentActiveTime(time);
    };

    const onClose = () => {
        contextValues.setToggleTimeSlotModal(!contextValues.toggleTimeSlotModal)
    }

    const selectTimeSlot = () => {
        if (currentActiveDate === '') {
            toast.error('Please choose date.');
            return;
        }

        if (currentActiveTime === '') {
            toast.error('Please choose time.');
            return;
        }
        const timeSlotData = {
            date: currentActiveDate,
            time: currentActiveTime,
        };

        localStorage.setItem('TIME_SLOT', JSON.stringify(timeSlotData));
        contextValues.setSelectedDateTime(timeSlotData);
        onClose()
    };

    const onChangeScheduleStaus = (type) => {
        if (type === 'lunch') {
            if (!contextValues.lunchDayTimeStatus) {
                localStorage.setItem('MENU_SCHEDULE', type)
                contextValues.setMenuSchedule(type)
                const timeSlotData = {
                    date: currentActiveDate,
                    time: currentActiveTime,
                };

                localStorage.setItem('TIME_SLOT', JSON.stringify(timeSlotData));
                contextValues.setSelectedDateTime(timeSlotData);
                onClose()
            } else {
                toast.error("Lunch order time has been ended for today");
            }
        }
        if (type === 'dinner') {
            if (!contextValues.dinnerDayTimeStatus) {
                localStorage.setItem('MENU_SCHEDULE', type)
                contextValues.setMenuSchedule(type)
                const timeSlotData = {
                    date: currentActiveDate,
                    time: currentActiveTime,
                };

                localStorage.setItem('TIME_SLOT', JSON.stringify(timeSlotData));
                contextValues.setSelectedDateTime(timeSlotData);
                onClose()
            } else {
                toast.error("Dinner order time has been ended for today");
            }
        }
    }

    const getScheduleTime = (newDate = new Date()) => {
        const today = new Date();
        const selectedDate = new Date(newDate);
        setCurrentActiveDate(selectedDate.toISOString().slice(0, 10))
        // Check if the selectedDate is the same as the current date
        const isSameDate =
            today.getFullYear() === selectedDate.getFullYear() &&
            today.getMonth() === selectedDate.getMonth() &&
            today.getDate() === selectedDate.getDate();

        if (!isSameDate) {
            // If not the same date, reset the status
            contextValues.setLunchDayTimeStatus(false);
            contextValues.setDinnerDayTimeStatus(false);
        } else {
            // Get current time in HH:mm:ss format
            const hours = today.getHours();
            const minutes = today.getMinutes();
            const seconds = today.getSeconds();
            const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

            if (contextValues?.settingData) {
                const { lunch_end_time, dinner_end_time } = contextValues.settingData;

                // Ensure both times are in the same format and are comparable
                const currentTime = moment(formattedTime, 'HH:mm:ss');
                const lunchEndTime = moment(lunch_end_time, 'HH:mm:ss');
                const dinnerEndTime = moment(dinner_end_time, 'HH:mm:ss');

                // Compare the times properly
                if (currentTime.isAfter(lunchEndTime)) {
                    contextValues.setLunchDayTimeStatus(true); // Lunch time is over 
                    contextValues.setMenuSchedule('dinner')
                } else {
                    contextValues.setLunchDayTimeStatus(false); // Lunch time is still available
                }

                if (currentTime.isAfter(dinnerEndTime)) {
                    contextValues.setDinnerDayTimeStatus(true); // Dinner time is over
                    contextValues.setMenuSchedule('lunch')
                } else {
                    contextValues.setDinnerDayTimeStatus(false); // Dinner time is still available
                }
            } else {
                console.error("contextValues or settingData is not properly defined.");
            }
        }
    };

    return (
        <>
            <Modal className="addressModal bottom" show={contextValues.toggleTimeSlotModal} onHide={(e) => { onClose() }}>
                <div className='addressModalContent'>
                    <button type="button" className="addressModalclose" onClick={() => { onClose() }}><i className="ri-close-line"></i></button>
                    <div className='addressModalContentInner'>
                        {contextValues.orderRecieveStatus === 'delivery' ?
                            <>
                                <div className="mb-20">
                                    <h5>Choose your Pickup Time</h5>
                                </div>
                                <div className='datelist'>
                                    <ul>
                                        {dates && dates.length > 0 && dates.map((dateData, index) => {
                                            return (
                                                <li
                                                    key={index}
                                                    className={currentActiveDate === dateData.completeDate ? 'active' : ''}
                                                    onClick={() => getScheduleTime(dateData.completeDate)}
                                                >
                                                    <span className='date'>{dateData.date}</span>
                                                    <span className='war tx-12 tx-gray'>{dateData.shortDay}</span>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                                <h5>Delivery Options</h5>
                                <div className="checkbox-body mb-20">
                                    <div className={`deilverop_box mt-10  ${contextValues.lunchDayTimeStatus ? 'disable' : contextValues.menuSchedule === 'lunch' ? 'active' : ''}`} onClick={() => { onChangeScheduleStaus('lunch') }}>
                                        <div className="deilverop_box_det">
                                            <div className="deilverop_box_det_icon">
                                                <img src='/img/lunch.png' alt="lunch time"></img>
                                            </div>
                                            <div className="deilverop_box_det_cont">
                                                <h6 className="mb-0">Lunch Time</h6>
                                                <p className="mb-0 tx-14">Order will be deliver before lunch time (10:30am – 1:00pm)</p>
                                                {contextValues.lunchDayTimeStatus && (<>
                                                    <p className="mb-0 tx-14 text-danger">Lunch order time has been ended for today ,  so lunch is no longer availale for today, order it for dinner.</p>
                                                    <p className="mb-0 tx-14 text-danger">Pickup might still be possible.</p>
                                                </>)}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`deilverop_box mt-10  ${contextValues.dinnerDayTimeStatus ? 'disable' : contextValues.menuSchedule === 'dinner' ? 'active' : ''}`} onClick={() => { onChangeScheduleStaus('dinner') }}>
                                        <div className="deilverop_box_det">
                                            <div className="deilverop_box_det_icon">
                                                <img src='/img/dinner.png' alt="dinner time"></img>
                                            </div>
                                            <div className="deilverop_box_det_cont">
                                                <h6 className="mb-0">Dinner Time</h6>
                                                <p className="mb-0 tx-14">Order will be deliver before dinner time (3:00pm – 7:00pm)</p>
                                                {contextValues.dinnerDayTimeStatus && (<>
                                                    <p className="mb-0 tx-14 text-danger">Dinner order time has been ended for today ,  so dinner is no longer availale for today, order it for lunch.</p>
                                                    <p className="mb-0 tx-14 text-danger">Pickup might still be possible.</p>
                                                </>)}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='mt-3'>
                                        <h6 className='text-danger'>Note:</h6>
                                        <p className='mb-0 tx-14'>- For urgent orders and deliveries please call <a href="tel:0490316092">0490 316 092</a> to discuss potential options (Extra Delivery Charges Apply)
                                        </p>
                                        <p className='mb-0 tx-14'>- For Areas outside our regular delivery area, call <a href="tel:0490316092">0490 316 092</a> to organise special delivery (Extra Delivery Charges Apply)
                                        </p>
                                    </div>
                                </div>
                            </>
                            :
                            <>
                                <div className="mb-20">
                                    <h5>Choose your Pickup Time</h5>
                                </div>
                                <div className='datelist'>
                                    <ul>
                                        {dates && dates.length > 0 && dates.map((dateData, index) => {
                                            return (
                                                <li
                                                    key={index}
                                                    className={currentActiveDate === dateData.completeDate ? 'active' : ''}
                                                    onClick={() => chooseDate(dateData)}
                                                >
                                                    <span className='date'>{dateData.date}</span>
                                                    <span className='war tx-12 tx-gray'>{dateData.shortDay}</span>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                                <h5>Pickup Times</h5>
                                <div className='timelist'>
                                    <ul>
                                        {isTimeLoader ?
                                            Array.from({ length: 18 }).map((_, index) => {
                                                return (
                                                    <li key={index}><Skeleton width={60} height={15} /></li>
                                                )
                                            })
                                            :
                                            timeSlots && timeSlots.length > 0 ? timeSlots.map((time, index) => {
                                                return (
                                                    <li
                                                        key={index}
                                                        className={currentActiveTime === time ? 'active' : ''}
                                                        onClick={() => chooseTime(time)}
                                                    >
                                                        {time}
                                                    </li>
                                                )
                                            })
                                                :
                                                <div className="noimg">
                                                    <img src="/img/notimeslot.png" className="mb-10" alt="Wish Wash" style={{ width: '100px' }} />
                                                    <h4 className="mb-0">No slot available at this date</h4>
                                                    <p>Please schedule your service at some other date !!</p>
                                                </div>
                                        }
                                    </ul>
                                </div>
                                {timeSlots && timeSlots.length > 0 &&
                                    <button type='button' className='btn btn-primary btn-lg btn-full' onClick={(e) => selectTimeSlot()}>Proceed to checkout</button>
                                }
                            </>
                        }
                    </div>
                </div>
            </Modal>
        </>
    )
}
export default TimeSlotModal